'use client';

import { motion } from 'framer-motion';
import { Navbar } from '../components/layout/navbar';
import { Footer } from '../components/layout/footer';

export default function AboutPage() {
    return (
        <div className="flex min-h-screen flex-col bg-black text-white selection:bg-violet-500/30">
            <div className="fixed inset-0 z-0 pointer-events-none">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-violet-600/20 blur-[120px]" />
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-cyan-600/20 blur-[120px]" />
            </div>

            <Navbar />

            <main className="flex-1 relative z-10 pt-24 pb-20">
                <section className="container px-4 md:px-6">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="max-w-4xl mx-auto text-center mb-24"
                    >
                        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-8">
                            We are reimagining <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-cyan-400">
                                online discourse
                            </span>
                        </h1>
                        <p className="text-xl text-zinc-400 leading-relaxed">
                            Talktrail is the Web3 evolution of community discussion. Built on the OriginTrail Decentralized Knowledge Graph, we empower communities with ownership, provenance, and AI-driven insights.
                        </p>
                    </motion.div>

                    {/* Mission Grid */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-32">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-white">Knowledge Assets, Not Just Posts</h2>
                            <p className="text-zinc-400 text-lg leading-relaxed">
                                Every discussion, every insight shared on Talktrail becomes a verifiable Knowledge Asset. You own your data, and your contributions are permanently etched into the Knowledge Graph.
                            </p>
                            <p className="text-zinc-400 text-lg leading-relaxed">
                                This enables a new era of "Knowledge Value" where high-quality contributions are recognized, rewarded, and utilized by AI agents across the ecosystem.
                            </p>
                        </div>
                        <div className="relative h-[400px] rounded-3xl overflow-hidden border border-white/10 bg-zinc-900/50">
                            <div className="absolute inset-0 bg-gradient-to-br from-violet-500/10 to-transparent" />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-32 h-32 rounded-full border-2 border-violet-500/30 flex items-center justify-center animate-pulse-slow">
                                    <div className="w-24 h-24 rounded-full bg-violet-500/20 backdrop-blur-md" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div className="relative h-[400px] rounded-3xl overflow-hidden border border-white/10 bg-zinc-900/50 order-2 md:order-1">
                            <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/10 to-transparent" />
                            <div className="absolute inset-0 flex items-center justify-center">
                                {/* Mock Graph */}
                                <svg viewBox="0 0 200 200" className="w-64 h-64 text-cyan-500/40">
                                    <circle cx="100" cy="100" r="5" fill="currentColor" />
                                    <circle cx="50" cy="50" r="3" fill="currentColor" />
                                    <circle cx="150" cy="50" r="3" fill="currentColor" />
                                    <circle cx="50" cy="150" r="3" fill="currentColor" />
                                    <circle cx="150" cy="150" r="3" fill="currentColor" />
                                    <path d="M100 100 L50 50 M100 100 L150 50 M100 100 L50 150 M100 100 L150 150" stroke="currentColor" strokeWidth="1" />
                                </svg>
                            </div>
                        </div>
                        <div className="space-y-6 order-1 md:order-2">
                            <h2 className="text-3xl font-bold text-white">AI Knowledge Pipelines</h2>
                            <p className="text-zinc-400 text-lg leading-relaxed">
                                Talktrail is designed for the AI era. Your community's knowledge doesn't just sit there; it fuels an AI pipeline that helps generate summaries, answer questions, and connect dots between disparately related topics in the Paranets.
                            </p>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}
